"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BinaryDto = void 0;
const AppDto_1 = require("../apps/AppDto");
const AppVersionDto_1 = require("../app-versions/AppVersionDto");
class BinaryDto {
    constructor(params) {
        this.binaryType = "";
        this.flurryApiKey = "";
        this.bugSenseApiKey = "";
        this.createdAt = "";
        this.updatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.appId = params.appId;
        this.appVersionId = params.appVersionId;
        this.binaryType = params.binaryType;
        this.flurryApiKey = params.flurryApiKey;
        this.bugSenseApiKey = params.bugSenseApiKey;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        if (params.app !== undefined) {
            this.app = params.app ? new AppDto_1.AppDto(params.app) : null;
        }
        if (params.appVersion !== undefined) {
            this.appVersion = params.appVersion ?
                new AppVersionDto_1.AppVersionDto(params.appVersion) : null;
        }
    }
}
exports.BinaryDto = BinaryDto;
//# sourceMappingURL=BinaryDto.js.map